import { RightArrowIcon } from '@jouzen/ecom-components/icons/RightArrowIcon';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import type { Department } from './types';

export interface DepartmentsListItemProps extends Department {
  readonly count: number;
  readonly index: number;
  readonly onClick: (department: string) => void;
}

interface ContentProps {
  readonly count: number;
  readonly name: string;
}

const DesktopContent = ({ count, name }: ContentProps) => {
  const t = useTranslations();
  return (
    <div className="hidden items-center justify-between md:flex">
      <Typography className="text-[1.375rem] lg:text-heading-lg" weight="light">
        {name}
      </Typography>
      <div className="items-center md:flex md:gap-x-48 xl:gap-x-96">
        <Typography variant="body-small" className="mt-2">
          {count} {t('open_roles')}
        </Typography>
        <RightArrowIcon />
      </div>
    </div>
  );
};

const MobileContent = ({ count, name }: ContentProps) => {
  const t = useTranslations();
  return (
    <div className="flex items-center justify-between md:hidden">
      <div>
        <Typography
          className="text-[1.375rem] lg:text-heading-lg"
          weight="light"
        >
          {name}
        </Typography>
        <Typography variant="body-small" className="mt-2">
          {count} {t('open_roles')}
        </Typography>
      </div>
      <RightArrowIcon />
    </div>
  );
};

const DepartmentsListItem = ({
  count,
  index,
  name,
  onClick,
}: DepartmentsListItemProps) => {
  const handleClick = () => {
    onClick(name);
  };

  return (
    <button
      className="relative block w-full border-x-0 border-solid border-transparent py-6 text-left text-sandstone-500"
      data-cy={`department-item-${index}`}
      key={`dept-${index}`}
      onClick={handleClick}
    >
      <DesktopContent name={name} count={count} />
      <MobileContent name={name} count={count} />
    </button>
  );
};

export default DepartmentsListItem;
